<template>
  <div
    class="FieldCheckbox"
    :class="{ error: canShowError, disabled }"
    @click="onClick"
  >
    <input
      :id="id"
      v-model="field.$model"
      :name="name"
      type="checkbox"
      :value="checkedValue"
      :disabled="disabled"
      :true-value="checkedValue"
      :false-value="uncheckedValue"
      class="field"
    />
    <label :for="id" class="label">
      <span class="icon icon-check" />
      <slot />
    </label>
    <field-error :show="canShowError">{{ errorMessage }}</field-error>
  </div>
</template>

<script>
import formField from "@mixins/form-field";
import FieldError from "@components/form/field-error";

export default {
  name: "FieldCheckbox",
  mixins: [formField],
  components: { FieldError },
  props: {
    label: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    checkedValue: {
      type: [Number, String, Boolean, Object, Array],
      default: true
    },
    uncheckedValue: {
      type: [Number, String, Boolean, Object, Array],
      default: false
    }
  },
  methods: {
    onClick() {
      if (this.disabled) {
        this.$emit("click-on-disabled");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~$scss/_variables.scss";

.FieldCheckbox {
  position: relative;
}

.field {
  position: absolute;
  left: -5000px;
  top: 0;
}

.label {
  display: block;
  position: relative;
  padding-left: 36px;
  font-size: 16px;
  --checkbox-offset-top: 2px;
  line-height: 1.4;

  @media (min-width: $bootstrap-md) {
    font-size: 18px;
    --checkbox-offset-top: 3px;
  }

  &:before {
    content: " ";
    display: block;
    background: $color-white;
    border: 1px solid rgba($color-dark, 0.25);
    border-radius: 5px;
    width: 20px;
    height: 20px;
    position: absolute;
    left: 0;
    top: var(--checkbox-offset-top);
    z-index: 1;
    transition: border 0.4s ease-in-out, background-color 0.4s ease-in-out;

    .error & {
      border-color: $color-error;
    }

    .disabled & {
      background: transparent;
    }
  }

  > .icon-check {
    display: block;
    position: absolute;
    left: 0;
    top: var(--checkbox-offset-top);
    font-size: 14px;
    padding: 3px;
    z-index: 2;
    color: $color-blue;
    opacity: 0;
    transform: scale(0.5);
    transition: all 0.2s ease-in-out;
  }

  .field:checked + & {
    > .icon-check {
      opacity: 1;
      transform: scale(1);
    }
  }

  ::v-deep {
    a {
      color: $color-blue;
      text-decoration: underline;
      transition: color 0.3s ease-in-out;
    }
  }
}
</style>
